import './assets/search-form.css';

const styles = civilCMSClassnames['search-form'];

const subscribeButtonConfig = {
  name: 'search-form',
  options: {
    styles,
  },
};

export default subscribeButtonConfig;
